var map = {
	"./bank-transfer.svg": 831,
	"./betnearn-ico.svg": 832,
	"./birthday-bonus-ico.svg": 833,
	"./birthday.svg": 834,
	"./bonus-code-ico.svg": 835,
	"./bonus-ico.svg": 836,
	"./bonus-received-ico.svg": 837,
	"./bonus.svg": 838,
	"./business-account-upgrade-ico.svg": 839,
	"./check-in-daily-ico.svg": 840,
	"./checked.svg": 841,
	"./cloud-pointer.svg": 842,
	"./coin.svg": 843,
	"./crypto.svg": 844,
	"./daily-bonus-ico.svg": 845,
	"./daily-limit.svg": 846,
	"./deposit-delay-bonus-ico.svg": 847,
	"./e-wallet.svg": 848,
	"./earn-x33-coin-ico.svg": 849,
	"./email.svg": 850,
	"./facebook.svg": 851,
	"./feedback.svg": 852,
	"./first-bet-ico.svg": 853,
	"./games-rebate-ico.svg": 854,
	"./info.svg": 855,
	"./instagram.svg": 856,
	"./instant-rebate.svg": 857,
	"./live-casino-rebate-ico.svg": 858,
	"./lucky-spin-ico.svg": 859,
	"./messenger.svg": 860,
	"./mobile-app-deposit-ico.svg": 861,
	"./monthly-cash.svg": 862,
	"./msg-activity.svg": 863,
	"./msg-ann.svg": 864,
	"./msg-notice.svg": 865,
	"./new-icon.svg": 866,
	"./people-ico.svg": 867,
	"./quick-pay.svg": 868,
	"./rescue-bonus-ico.svg": 869,
	"./rescue-lc-ico.svg": 870,
	"./rescue-slots-ico.svg": 871,
	"./return.svg": 872,
	"./sc-bc-active-ico.svg": 873,
	"./sc-bc-ico.svg": 874,
	"./sc-bi-active-ico.svg": 875,
	"./sc-bi-ico.svg": 876,
	"./sc-mail-active-ico.svg": 877,
	"./sc-mail-ico.svg": 878,
	"./sc-mp-active-ico.svg": 879,
	"./sc-mp-ico.svg": 880,
	"./sc-pin-active-ico.svg": 881,
	"./sc-pin-ico.svg": 882,
	"./slots-rebate-ico.svg": 883,
	"./sms.svg": 884,
	"./sports-rebate-ico.svg": 885,
	"./telegram.svg": 886,
	"./twitter.svg": 887,
	"./vip-up-level-ico.svg": 888,
	"./vip-weekly-bonus.svg": 889,
	"./wallet-balance-interest-ico.svg": 890,
	"./wallet-ico.svg": 891,
	"./weekly-tournament-ico.svg": 892,
	"./welcome-bonus-188-ico.svg": 893,
	"./welcome-bonus-ico.svg": 894,
	"./whatsapp-original.svg": 895,
	"./whatsapp.svg": 896,
	"./withdrawal-delay-bonus-ico.svg": 897,
	"./withdrawal.svg": 898,
	"./x33-coin.svg": 899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1933;